import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InsuranceTableComponent } from '../../../componentes/insurance-table/insurance-table.component';
import { TableConfig } from '../../../interfaces/table-config.interface';
import { UtilitariosService } from '../../../services/utilitarios.service';
import { AuthService } from '../../../services/auth.service';
import { WorkshopListResponse } from '../../../interfaces/utilitarios.interface';
import { ApiResponse } from '../../../interfaces/common.interfaces';
import { LoadingService } from '../../../error&timer/loading.service';
import { Observable } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { generateTipMessage } from '../../../services/tips';
import { ExportarComponent } from '../../../componentes/exportar/exportar.component';
import { GoogleAnalyticsService } from '../../../services/google-analytics/google-analytics.service';

@Component({
  selector: 'app-talleres-afiliados',
  standalone: true,
  imports: [
    InsuranceTableComponent,
    CommonModule,
    FormsModule,
    ExportarComponent,
  ],
  templateUrl: './talleres-afiliados.component.html',
  styleUrl: './talleres-afiliados.component.css',
})
export class TalleresAfiliadosComponent implements OnInit {
  workShops!: WorkshopListResponse[];
  workShopZones: string[] = [];
  selectedZone: string = 'Todos';
  filteredWorkshops: WorkshopListResponse[] = [];
  mensajeNoData: string = 'Selecciona los campos que deseas buscar';
  errorStatus?: number;
  title: string = '';

  constructor(
    private authService: AuthService,
    private utilitariosService: UtilitariosService,
    private gAnalytics: GoogleAnalyticsService
  ) {
    this.title = 'Talleres Afiliados';
  }

  // Referencia al componente de la tabla
  @ViewChild(InsuranceTableComponent) tablaComponent!: InsuranceTableComponent;

  // Configuración de la tabla
  tableConfig: TableConfig = {
    columns: [
      {
        key: 'providerName',
        label: 'Taller',
        sortable: true,
      },
      {
        key: 'providerPhone',
        label: 'Telefono',
      },
      {
        key: 'providerAddress',
        label: 'Dirección',
      },
    ],
    showTotals: true,
  };

  ngOnInit() {
    const request = {
      producerNumber: this.authService.getProducerNumber() || 0,
    };

    this.utilitariosService.getWorkShop(request).subscribe({
      next: (response: ApiResponse<WorkshopListResponse[]>) => {
        // Extraer y almacenar las zonas únicas, incluyendo 'Todos' al inicio
        this.workShopZones = [
          'Todos',
          ...new Set(response.data.map((shop) => shop.workShopZone || '')),
        ];
        this.workShops = response.data;
        this.handleSelectedZoneChange();
      },
      error: (error) => {
        console.error('Error al cargar documentos:', error);
        if (error.status === 404) {
          window.alert('No se encontraron datos de contactos');
        }
      },
    });
  }

  handleSelectedZoneChange() {
    if (this.selectedZone === 'Todos') {
      this.filteredWorkshops = this.workShops;
    } else {
      this.filteredWorkshops = this.workShops.filter(
        (workshop) => workshop.workShopZone === this.selectedZone
      );
    }

    // Reiniciar la página a 1 cuando cambie la zona
    if (this.tablaComponent) {
      this.tablaComponent.currentPage = 1;
      this.tablaComponent.updatePaginatedData();
    }
  }

  // Exportar datos
  onExportar(formato: string): void {
    if (this.tablaComponent) {
      const headerInfo = {
        titulo: 'Talleres Afiliados',
        fecha1: new Date(),
        tableConfig: this.tableConfig,
        lob: '',
        slob: '',
      };

      //Evento para trackear las exportaciones de archivos en Google Analytics
      this.gAnalytics.trackEvent('talleres_afialiados_descargas',{
        page:'/talleres-afiliados',
        format:formato
      })

      this.tablaComponent.exportarDatos(formato, headerInfo);
    }
  }
}
